/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssueTypesScreenSchemesRoute } from '@jira/router-routes__admin-pages-screens-routes/src/globalSettingsIssueTypesScreenSchemesRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import IssueTypeScreenSchemesPage, {
	LazyIssueTypeScreenSchemesPage,
} from './ui/spa/admin-pages/screens/issue-type-screen-schemes-page/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsIssueTypesScreenSchemesRouteEntry: Route = createEntry(
	globalSettingsIssueTypesScreenSchemesRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.issue-type-screen-schemes',
		// eslint-disable-next-line no-restricted-syntax
		component: IssueTypeScreenSchemesPage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyIssueTypeScreenSchemesPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
